import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Button,
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import moment from "moment";

import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import { IDCReport } from "../../../store/discipline/actions";
import { textCapitalized } from "../../common/components/Utils";
import { showError } from "../../toastify";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const CommitteeReportFormDialog = (props) => {
  const {
    loading,
    showCommitteeReportForm,
    setShowCommitteeReportForm,
    caseRequest,
    IDCReport,
  } = props;
  const { hasPermissions } = useRequiredAuth();

  const decisions = [
    {
      key: "GIVE_SANCTION",
      title: "Impose the sanction",
    },
    {
      key: "WAITING_TO_CLOSE_CASE",
      title: "Close the case without sanction",
    },
  ];
  const [currentSelectedDecision, setCurrentSelectedDecision] = useState(null);
  const [pdfAttachment, setPdfAttachment] = useState(null);
  const fileInputRef = useRef(null);
  const [fileUrl, setFileUrl] = useState(null);

  const [formData, setFormData] = useState({
    caseId: caseRequest?.request?.id || "",
    decisionTaken: "",
    reportCommitteeSummary: caseRequest?.request?.reportCommitteeSummary || "",

    reportCommitteeDate: caseRequest?.request?.reportCommitteeDate
      ? moment(caseRequest?.request?.reportCommitteeDate || null).format(
          "YYYY-MM-DD"
        )
      : null,

    pdfAttachment: null,
  });

  const [errors, setErrors] = useState({
    hasError: false,
    effectiveDateError: false,
    reportCommitteeSummaryHasError: false,
    pdfAttachmentHasError: false,
    decisionTakenHasError: false,
  });

  const formValidator = () => {
    const error = {
      hasError: false,
      effectiveDateError: false,
      reportCommitteeSummaryHasError: false,
      pdfAttachmentHasError: false,
      decisionTakenHasError: false,
    };

    if (!pdfAttachment) {
      error.pdfAttachmentHasError = true;
      error.hasError = true;
    }

    if (!formData.decisionTaken) {
      error.decisionTakenHasError = true;
      error.hasError = true;
    }

    if (!formData.reportCommitteeDate) {
      error.effectiveDateError = true;
      error.hasError = true;
    }
    if (!formData.reportCommitteeSummary) {
      error.reportCommitteeSummaryHasError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      showError("Please fill the required field");
      return true;
    }
    return false;
  };
  const onClose = () => {
    setShowCommitteeReportForm(false);
  };

  const onSave = () => {
    if (!formValidator()) {
      console.log(formData);
      const payload = new FormData();
      formData.file = pdfAttachment;
      const keys = Object.keys(formData);
      for (const key of keys) {
        if (key === "file" && formData[key]) payload.append(key, formData[key]);
        else payload.append(`${key}`, `${formData[key]}`);
      }
      IDCReport(payload, caseRequest, onClose);
    }
  };

  const convertToLower = (value) => {
    return value.toLowerCase();
  };

  const isFileTooLarge = (file) => {
    const size = file.size;
    return size > 2074190 ? true : false;
  };

  const handleUploadedPDFFile = (event) => {
    setErrors({ ...errors, pdfAttachmentHasError: false });
    setPdfAttachment(null);
    let pdfAttachment = event.target.files[0];

    if (
      convertToLower(pdfAttachment?.name?.substr(-4)) !== ".pdf" &&
      pdfAttachment?.type !== "application/pdf"
    ) {
      setErrors({ ...errors, pdfAttachmentHasError: true });
      showError("File should be pdf format");
      fileInputRef.current.value = "";
    } else if (isFileTooLarge(pdfAttachment)) {
      setErrors({ ...errors, pdfAttachmentHasError: true });
      showError("Allowed file should not exceed 2MB");
      fileInputRef.current.value = "";
    } else {
      const reader = new FileReader();

      reader.onload = (e) => {
        setFileUrl(e.target.result);
      };

      reader.readAsDataURL(pdfAttachment);

      setPdfAttachment(pdfAttachment);
    }
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showCommitteeReportForm}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle>
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            Summary of Internal Discipline Committee Report /{" "}
            <span className="text-primary">
              {textCapitalized(caseRequest?.request?.lastName)}
              {textCapitalized(caseRequest?.request?.firstName)}
            </span>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="pb-2">
          <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
            <div className="card service-card valid mb-2 mt-3">
              <div
                className="card-header  d-flex justify-content-between align-items-center"
                style={{ padding: "0.25rem 1.2rem" }}
              >
                Select a decision taken by Internal Disciplinary Committee.
              </div>
              <div className="card-body">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    // defaultValue="female"
                    name="radio-buttons-group"
                    className="p-0 m-0"
                  >
                    {decisions.map((decision, index) => (
                      <FormControlLabel
                        key={decision.key}
                        value={decision.key}
                        control={<Radio />}
                        label={decision.title}
                        onChange={() => {
                          setCurrentSelectedDecision(decision);
                          setFormData({
                            ...formData,
                            decisionTaken: decision.key,
                          });

                          setErrors({
                            ...errors,
                            decisionTakenHasError: false,
                          });
                        }}
                        checked={currentSelectedDecision?.key === decision.key}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
                {errors.decisionTakenHasError && (
                  <p>
                    {" "}
                    <small className="text-danger mb-1">
                      Please, select a decision taken
                    </small>
                  </p>
                )}
              </div>
            </div>
            <div className="card service-card valid mb-2 mt-1">
              <div className="card-body">
                <div className="p-0 mb-2">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      label="Please specify the date of the Internal Disciplinary Committee's approved report."
                      inputFormat="dd/MM/yyyy"
                      minDate={moment(
                        caseRequest?.request?.currentDate || new Date()
                      ).subtract(30, "days")}
                      maxDate={moment(
                        caseRequest?.request?.currentDate || new Date()
                      ).add(30, "days")}
                      value={formData.reportCommitteeDate}
                      onChange={(date) => {
                        setFormData({
                          ...formData,
                          reportCommitteeDate: date,
                        });

                        setErrors({
                          ...errors,
                          effectiveDateError: false,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(e) => e.preventDefault()}
                          required={true}
                          fullWidth
                          size="small"
                          {...params}
                        />
                      )}
                    />

                    {errors.effectiveDateError && (
                      <small className="text-danger mt-1">
                        The date is required{" "}
                      </small>
                    )}
                  </LocalizationProvider>
                </div>
                <div className="card service-card valid mb-1 mt-3">
                  <div
                    className="card-header"
                    style={{ padding: "0.25rem 1.2rem" }}
                  >
                    Please attach the report of the Internal Disciplinary
                    Committee.
                  </div>
                  <div className="card-body">
                    <div className={`p-0`}>
                      <Button fullWidth component="label" size="md">
                        <div className="w-100">
                          <input
                            type="file"
                            accept="application/pdf"
                            placeholder="Please attach the report of the Internal Disciplinary Committee."
                            onChange={(e) => handleUploadedPDFFile(e)}
                            ref={fileInputRef}
                            className="w-100"
                          />
                        </div>
                      </Button>
                    </div>
                    {errors.pdfAttachmentHasError && (
                      <p>
                        <div className="w-100">
                          <small className="text-danger mt-1">
                            Please, attachment is required
                          </small>
                        </div>
                      </p>
                    )}
                  </div>
                </div>

                <div className="p-0 mt-3">
                  <TextField
                    fullWidth
                    size="small"
                    name="reportCommitteeSummary"
                    required={true}
                    multiline
                    rows={3}
                    value={formData.reportCommitteeSummary}
                    label={`Please specify the summary of the committee's conclusions. `}
                    placeholder={`Please specify the summary of the committee's conclusions.`}
                    inputProps={{ maxLength: 300 }}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        reportCommitteeSummary: e.target.value,
                      });

                      setErrors({
                        ...errors,
                        reportCommitteeSummaryHasError: false,
                      });
                    }}
                  />
                  <strong className="text-right float-right text-primary w-100">
                    Should not exceed the 300-character limit.
                  </strong>
                  {errors.reportCommitteeSummaryHasError && (
                    <small className="text-danger mb-1">
                      Please, type the summary of the committee's conclusions.
                    </small>
                  )}
                </div>
              </div>
            </div>
          </Box>
        </DialogContent>

        {!!hasPermissions(["IS_HR"]) && (
          <>
            <DialogActions className="d-flex justify-content-center py-2">
              <Button
                variant="contained"
                color="success"
                type="button"
                disabled={loading}
                onClick={() => {
                  onSave();
                }}
                className="btn btn-xs"
              >
                {loading ? "Wait.." : "Submit"}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading }) => {
  return {
    loading,
  };
};
export default connect(mapStateToProps, {
  IDCReport,
})(CommitteeReportFormDialog);
